import I18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import common_es from "./config/locales/es-ES.json";

I18n
    .use(LanguageDetector)
    .init({
        fallbackLng: 'es',
        whitelist: ['es'],
        lng: 'es',
        resources: {
            es: {
                common: common_es
            }
        },
        defaultNS: 'common',
        interpolation: {
            // i18next escapa a HTML todo lo que interpola, asi que una fecha salia
            // en pantalla como `08&#x2F;10&#x2F;2027`: el escapado se aplicaba al
            // texto y nadie lo volvia a decodificar. Aqui las traducciones se
            // renderizan siempre como texto de React, que ya escapa por su cuenta,
            // y en todo el proyecto no hay un solo `dangerouslySetInnerHTML` donde
            // pudiera colarse el valor como marcado.
            escapeValue: false
        }
    });


export default I18n;